import type { PropertiesGroupByKey } from '../types/riskProfileProperties.types'

export const PROFILE_SOCIAL_ECONOMIC_WIDGETS = {
  residentsByDemographic: {},
  residentsByHazard: {
    groupBy: 'hazard_group' as const,
  },
  residentsByArea: {
    groupBy: 'region_group' as PropertiesGroupByKey,
  },
  disruptionBySector: {},
  disruptionByHazard: {
    groupBy: 'hazard_group' as const,
  },
  disruptionByArea: {
    groupBy: 'region_group' as PropertiesGroupByKey,
  },
} as const

export const FALLBACK_DOT_COLOUR = 'hsl(190 54% 51%)'
